import Vue, { PropType } from 'vue';

import { 部門ListItemResponse } from '@/openapi/user';

type Option = {
  label: string;
  pk: number | undefined;
};

export default Vue.extend({
  name: 'C部門Select',

  props: {
    部門s: {
      type: Array as PropType<部門ListItemResponse[]>,
      default: () => [],
    },
    pk: {
      type: Number,
    },
    /** 先頭に「合計」の要素を追加するかどうか　「合計」選択時はundefinedを返す */
    hasTotal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options(): Option[] {
      const options: Option[] = this.部門s.map((部) => {
        return {
          label: 部.c部門名,
          pk: 部.pk,
        };
      });
      if (this.hasTotal) options.unshift({ label: '合計', pk: undefined });
      return options;
    },
    selected: {
      get(): number | undefined {
        let pk: number | undefined = this.pk;

        // optionsが1件もない場合はundefinedをreturn
        if (this.options.length === 0) return undefined;

        // pkがoptionsに存在しない場合は最初の項目を設定する
        const find = this.options.find((o) => o.pk === this.pk);
        if (find === undefined) {
          pk = this.options[0].pk;
          this.$emit('update:pk', this.options[0].pk);
        }

        return pk;
      },
      set(pk: number | undefined): void {
        this.$emit('update:pk', pk);
      },
    },
  },
});
